/**
 * Подмножество ответа Telegram, нужное для сверки. 02-contracts.md §4.3.
 *
 * looseObject здесь ОБЯЗАТЕЛЕН и противоположен strictObject на intake: входящее от Telegram
 * нельзя отбивать за незнакомые поля — сервер волен добавлять их в любой момент, и наша
 * сверка не должна падать из-за нового поля, которого мы не просили.
 *
 * И ЕЩЁ ОДНА ПРИЧИНА, ТЕПЕРЬ НЕСУЩАЯ. Поле `rich_message` в этой схеме НЕ ОБЪЯВЛЕНО, а сверка
 * (`verify.ts`, §Ключ 6) читает дерево блоков именно из него. Живёт оно здесь ровно потому,
 * что `looseObject` неизвестные поля СОХРАНЯЕТ, а не выбрасывает.
 *
 * Значит «ужесточить схему до strictObject» — правка, которая выглядит как закручивание гаек,
 * а на деле вырезает у сверки её единственный источник: каждый корректно опубликованный
 * rich-пост стал бы `rich_message_missing`, то есть critical `publish_deviation` на посте,
 * с которым всё в порядке. Не делать. Объявлять `rich_message` полем схемы тоже не надо:
 * его форму нормализует сервер (`rich.ts`, шапка), и всякое объявление здесь было бы
 * утверждением о форме, которого мы не можем сдержать.
 */

import * as z from 'zod';

const IncomingEntitySchema = z.looseObject({
  type: z.string(),
  offset: z.int(),
  length: z.int(),
  url: z.string().optional(),
  language: z.string().optional(),
  custom_emoji_id: z.string().optional(),
  user: z.looseObject({ id: z.int() }).optional(),
});

export type IncomingEntity = z.output<typeof IncomingEntitySchema>;

export const TelegramMessageSchema = z.looseObject({
  message_id: z.int(),
  date: z.int(),
  chat: z.looseObject({ id: z.union([z.int(), z.string()]) }),
  text: z.string().optional(),
  entities: z.array(IncomingEntitySchema).optional(),
  caption: z.string().optional(),
  caption_entities: z.array(IncomingEntitySchema).optional(),
  photo: z.array(z.looseObject({ file_id: z.string() })).optional(),
  link_preview_options: z
    .looseObject({
      is_disabled: z.boolean().optional(),
      url: z.string().optional(),
      prefer_small_media: z.boolean().optional(),
      prefer_large_media: z.boolean().optional(),
      show_above_text: z.boolean().optional(),
    })
    .optional(),
});

export type TelegramMessage = z.output<typeof TelegramMessageSchema>;
